/*
 * Custom Accessibility Fixes
 * Keeps a11y overrides separate from core Habitat theme files.
 * Loaded after app.js in theme.liquid.
 */
(function () {
  'use strict';

  /* ---- PanelClose (side-panel-close) ---- */
  function enhancePanelClose() {
    document.querySelectorAll('side-panel-close').forEach(function (el) {
      if (el.hasAttribute('data-a11y')) return;
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', el.textContent.trim());
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          el.click();
        }
      });
      el.setAttribute('data-a11y', '');
    });
  }

  /* ---- Clipboard bubble aria-hidden toggle ---- */
  function enhanceClipboard() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName !== 'class') return;
        var btn = mutation.target;
        if (!btn.classList.contains('clipboard')) return;
        var bubble = btn.querySelector('.clipboard--bubble');
        if (!bubble) return;
        bubble.setAttribute(
          'aria-hidden',
          btn.classList.contains('clipboard-success') ? 'false' : 'true'
        );
      });
    });
    document.querySelectorAll('.clipboard.social').forEach(function (btn) {
      observer.observe(btn, { attributes: true, attributeFilter: ['class'] });
    });
  }

  /* ---- noUiSlider — handle labels + wrapper roles ---- */
  function enhanceSliders() {
    document.querySelectorAll('.noUi-target').forEach(function (slider) {
      if (slider.hasAttribute('data-a11y')) return;
      var handles = slider.querySelectorAll('.noUi-handle');
      if (handles[0]) handles[0].setAttribute('aria-label', 'Minimum price');
      if (handles[1]) handles[1].setAttribute('aria-label', 'Maximum price');
      slider
        .querySelectorAll('.noUi-base, .noUi-connects, .noUi-origin')
        .forEach(function (el) {
          el.setAttribute('role', 'presentation');
        });
      slider.setAttribute('data-a11y', '');
    });
  }

  /* ---- Flickity — presentational wrappers + thumbnail keyboard ---- */
  function enhanceProductSlider() {
    document.querySelectorAll('product-slider').forEach(function (slider) {
      slider
        .querySelectorAll('.flickity-viewport, .flickity-slider')
        .forEach(function (el) {
          el.setAttribute('role', 'presentation');
          el.removeAttribute('tabindex');
        });
      slider
        .querySelectorAll('.product-thumbnail[role="button"]')
        .forEach(function (thumb) {
          if (thumb.hasAttribute('data-a11y')) return;
          thumb.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              thumb.click();
            }
          });
          thumb.setAttribute('data-a11y', '');
        });
    });
  }

  /* ---- Bootstrap ---- */
  function init() {
    enhancePanelClose();
    enhanceClipboard();
    enhanceSliders();
    enhanceProductSlider();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run for dynamically added elements (drawers, AJAX facets, etc.) */
  new MutationObserver(function () {
    enhancePanelClose();
    enhanceSliders();
    enhanceProductSlider();
  }).observe(document.body || document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
